module.exports = __webpack_public_path__ + "static/media/home-slider-banner-5.9f5adfe2.png";